import axios from 'axios'

const instance = axios.create({
    baseURL: import.meta.env.VITE_BASE_API_URL,
    timeout: Number(import.meta.env.VITE_API_TIMEOUT),
})

export default instance
